import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Button from 'shared/components/Button';
import extPlaceholder from 'assets/images/extension_placeholder.png';
import { openExtensionUrl } from 'utils/urlHelpers';

const StepAddLikieeExt = () => {
  const { t } = useTranslation();

  const onInstallExt = () => {
    openExtensionUrl();
  };

  return (
    <div className='d-flex flex-md-nowrap flex-wrap onboarding-extension'>
      <img alt='extPlaceholder' width='420' src={extPlaceholder} />
      <div className='ml-0 mt-10 mt-md-0 ml-md-16'>
        <h2 className='mb-6 mb-md-8'>{t('onboarding_add_likiee_ext_title')}</h2>
        <p className='mb-12'>
          <Trans i18nKey='onboarding_add_ext_likiee_desc' />
        </p>
        <Button className='btn-outline-primary' onClick={onInstallExt}>
          {t('btn_install_extension')}
        </Button>
      </div>
    </div>
  );
};

export default StepAddLikieeExt;
